import { Button } from '@shared/components/ui/button';
import { Input } from '@shared/components/ui/input';
import { Label } from '@shared/components/ui/label';
import { useTranslation } from 'react-i18next';
import { FilterConditionOutput } from '@shared/components/ui/AdvancedFilter';
import { useWalletsFilters } from '../../hooks/useWalletsFilters';

interface WalletsFiltersPanelProps {
  initialConditions: FilterConditionOutput[];
  onChange: (conditions: FilterConditionOutput[]) => void;
}

export const WalletsFiltersPanel = ({ initialConditions, onChange }: WalletsFiltersPanelProps) => {
  const { t } = useTranslation('walletsModule');
  const { filters, handleFilterChange, clearFilters } = useWalletsFilters({ initialConditions, onChange });

  return (
    <div className="space-y-4 min-w-[300px]">
      <div className="space-y-2">
        <Label>{t('filters.currency.label', 'Moneda')}</Label>
        <Input
          placeholder={t('filters.currency.placeholder', 'Ej: USD, EUR')}
          value={filters.currency}
          onChange={(e) => handleFilterChange('currency', e.target.value)}
        />
      </div>

      <div className="space-y-2">
        <Label>{t('filters.balanceTotal.label', 'Balance Total')}</Label>
        <div className="flex gap-2">
          <Input
            type="number"
            placeholder="Min"
            value={filters.balanceMin}
            onChange={(e) => handleFilterChange('balanceMin', e.target.value)}
          />
          <Input
            type="number"
            placeholder="Max"
            value={filters.balanceMax}
            onChange={(e) => handleFilterChange('balanceMax', e.target.value)}
          />
        </div>
      </div>

      <div className="pt-2">
        <Button
          variant="outline"
          className="w-full"
          onClick={clearFilters}
          disabled={!filters.currency && !filters.balanceMin && !filters.balanceMax}
        >
          {t('filters.clear', 'Limpiar filtros')}
        </Button>
      </div>
    </div>
  );
};
